import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import './index.css';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const DataGrid = ({ data, headers, defaultOrder = 'asc', defaultOrderBy }) => {
  const [order, setOrder] = React.useState(defaultOrder);
  const [orderBy, setOrderBy] = React.useState(defaultOrderBy);

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <>
      <TableContainer
        component={Paper}
        className={data.length > 8 ? 'scrollable-table' : 'fix-height-table'}
      >
        <Table
          stickyHeader
          aria-label="simple table"
          style={data.length > 8 ? { minHeight: 650 } : null}
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <strong>Rank</strong>
              </TableCell>
              {headers.map((item, index) => (
                <TableCell align={item.numeric ? 'right' : 'left'}>
                  <TableSortLabel
                    active={orderBy === item.sortColumn}
                    direction={orderBy === item.sortColumn ? order : 'asc'}
                    onClick={createSortHandler(item.sortColumn)}
                  >
                    <strong>{item.label}</strong>
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.sort(getComparator(order, orderBy)).map((row, index) => (
              <TableRow key={row.name}>
                <TableCell align="center">{index + 1}</TableCell>
                {headers.map((item, i) => (
                  <TableCell align={item.numeric ? 'right' : 'left'}>
                    {Object.values(row)[Object.keys(row).indexOf(item.dataColumn)]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
export default DataGrid;
